<template>
<transition name="fade">
    <div v-if="hasChanges">
        <b-col cols="9" class="text-left">
            <div class="inputSearch">
                <b-row class="w100 text-center" style="margin-top:20px;margin-bottom:0">
                    <div>
                        <!-- cancel -->
                        <button @click="onCancel()" class="btn"> {{ $t("messages.cancel") }} </button>
                    </div>
                    <div class="mleft20">
                        <!-- save -->
                        <button @click="onSave()" class="btn"> {{ $t("messages.save") }} </button>
                    </div>
                </b-row>
            </div>
        </b-col>
    </div>
</transition>

</template>

<script>
export default {
    name: 'Actions',
    props: {
        hasChanges: 0
    },
    data() {
        return {
        }
    },
    methods:{
       onSave(){
            this.$emit('onSave');
       },
       onCancel(){
            this.$emit('onCancel');
       }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/Actions.vue